import _ from "lodash";
import { usePermission } from "../modules/core/composables/usePermission";

// เดิมหน้า /login ที่มี cookie `xtable` (beta redirect) จะถูกส่งกลับ "/" เพราะถือว่า
// cookie = login แล้ว ตอนนี้ cookie ไม่ใช่การ login (ดู modules/core/utils/authHandoff.ts)
// ถ้ายังส่งกลับอยู่จะวน /login -> "/" -> ไม่มี session -> /login ไม่จบ
export default defineNuxtRouteMiddleware((to, from) => {
  if (to.meta?.freeAuth) {
    return;
  }


  //----   default path is ok
  if (to.path == "/") {
    return;
  }

  if (to.path == "/topup/promptpay") {
    return;
  }

  const resultCheck = usePermission().checkPermissionPage(to.path);
  if (!resultCheck) {
    return navigateTo("/notallowed?from=" + to.path);
  }
});
